export enum OnboardingPopupStepsEnum {
  Initial = 0,
  Onboarding = 1,
  AddressRequest = 2,
  AgeVerification = 3,
  EmailVerified = 4,
  OnARoll = 5,
  LocationPermissionRequest = 6,
  ProfileInformationRequest = 7,
  FlashMissionsOnboarding = 8,
  MissionReferral = 9,
  Completed = 99,
}
